import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getUser } from "Util/index";
import { pathPortal } from "Path";
import { shouldRedirectToPortal } from "./routeGuard";

/**
 * Top-level route boundary (portal-clientes-rediseno, Phase 8 / Scope F).
 * Design decision F: a hard redirect at the top of the route tree, rather
 * than retrofitting per-route <Policy> wrappers — Entry.js's `pages` array
 * carries no policy metadata to hang a per-route check on.
 *
 * Wrap the whole routed app tree with this component (see Entry.js). Any
 * customer-portal user (JWT payload carries `customer`) navigating to a
 * path outside `/portal` is redirected there instead of rendering the
 * internal route's real content.
 */
const CustomerRouteBoundary = ({ children }) => {
  const location = useLocation();
  const user = getUser();

  if (shouldRedirectToPortal(user, location.pathname)) {
    return <Navigate to={pathPortal.home} replace />;
  }

  return children;
};

export default CustomerRouteBoundary;
